/** Routes that fill <main> edge-to-edge and manage their own internal scroll/layout. */
export function isFullBleedRoute(pathname: string): boolean {
    if (
        pathname === '/workbench'
        || pathname === '/demo/workbench'
        || pathname === '/fusion'
        || pathname === '/demo/fusion'
        || pathname === '/instagram-network'
    ) {
        return true;
    }
    return /^\/cases\/[^/]+\/canvas$/.test(pathname);
}
